export default ($container) => {
    $('.js-side-bar-open', $container).click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        let $href = $(this).attr('href');

        $($href).addClass('is-active');
        $('body, html, .wrapper, .header__container').addClass('is-active');
    });

    $('.js-side-bar-close', $container).click(function(e) {
        e.preventDefault();
        e.stopPropagation();
        let $href = $(this).attr('href');

        $($href).removeClass('is-active');
        $('body, html, .wrapper, .header__container').removeClass('is-active');
    });

    $('.side-bar', $container).click(function(e) {
        e.stopPropagation();
    });

    if($container.is('body')){
        $('body, html, .wrapper').click(function() {
            $('.side-bar, .header__container, #filter').removeClass('is-active');
        });
    }
};
